import React, { Component } from 'react';
import Email from '../img/social-email.png';
import Twitter from '../img/social-twitter.png';
import Facebook from '../img/social-facebook.png';
import LinkedIn from '../img/social-linkedin.png';

import EmailBlack from '../img/social-email-black.png';
import TwitterBlack from '../img/social-twitter-black.png';
import FacebookBlack from '../img/social-facebook-black.png';
import LinkedInBlack from '../img/social-linkedin-black.png';
import '../css/App.css';

class Social extends Component {
  componentDidMount() {

  }
  render() {
    const title = encodeURIComponent(this.props.title);
    const twitterTitle = encodeURIComponent(this.props.twitterTitle);
    var url = encodeURIComponent(this.props.url);

     if(!this.props.mfm) {
       let newURL = this.props.url;
       newURL = newURL.replace(".com/", ".com/msd/");
       url = encodeURIComponent(newURL);
     }

      return (
      <div className="social">
        <ul>
          <li><a id="link_email" target="_blank" href={"mailto:?subject="+title+"&body="+url} onClick={() => {this._analytics('Email',this.props.pageSection)}}><img src={this.props.color === 'white' ? Email : EmailBlack} alt="Email" /></a></li>
          <li><a id="link_twitter" target="_blank" href={"https://twitter.com/intent/tweet/?text="+twitterTitle+"&url="+url} onClick={() => {this._analytics('Twitter',this.props.pageSection)}}><img src={this.props.color === 'white' ? Twitter : TwitterBlack} alt="Twitter" /></a></li>
          <li><a id="link_facebook" target="_blank" href={"https://www.facebook.com/sharer/sharer.php?u="+url} onClick={() => {this._analytics('Facebook',this.props.pageSection)}}><img src={this.props.color === 'white' ? Facebook : FacebookBlack} alt="Facebook" /></a></li>
          <li><a id="link_linkedin" target="_blank" href={"https://www.linkedin.com/shareArticle?mini=true&url="+url+"&title="+title+"&summary="+title+"&source="+url} onClick={() => {this._analytics('LinkedIn',this.props.pageSection)}}><img src={this.props.color === 'white' ? LinkedIn : LinkedInBlack} alt="LinkedIn" /></a></li>
        </ul>
      </div>
    );
  }

  _analytics(network,source) {
    window.gtag('event','share'+" — "+source+" — "+network,{'event_category':'Social Media','event_label':network});
  }
}

Social.defaultProps = {
  title: 'Merck for Mothers',
  twitterTitle: 'Merck for Mothers',
  url: window.location.origin,
  color: 'white',
  mfm: false
};

export default Social;



// WEBPACK FOOTER //
// ./src/js/Social.js